import React from 'react';
// @ts-ignore
import variables from 'styles/_variables.scss';
import { IIconProps } from './IIconProps';

export const ResultModalIcon = ({ iconClass = '', title = '' }: IIconProps) => {
	return (
		<svg
			viewBox="0 0 56 44"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={iconClass}
		>
			<rect
				x="3.5"
				y="11.5"
				width="27"
				height="22"
				rx="1.5"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M8.5 8C8.5 4.41015 11.4101 1.5 15 1.5H19C22.5899 1.5 25.5 4.41015
				25.5 8V11.5H8.5V8Z"
				stroke={variables.bgIconChevron}
			/>
			<rect x="8" y="22" width="2" height="2" fill={variables.bgIconChevron} />
			<rect x="16" y="22" width="2" height="2" fill={variables.bgIconChevron} />
			<rect x="24" y="22" width="2" height="2" fill={variables.bgIconChevron} />
			<circle
				cx="38.5"
				cy="31.5"
				r="11.5"
				fill="white"
				stroke={variables.bgIconChevron}
			/>
			<path
				d="M54.3327 18.5L38.7493 34.0833L31.666 27"
				stroke={variables.bgIconChevron}
			/>
		</svg>
	);
};
